export default "/bundles/assets/photoMany_0cc4ffb9bae42cef7e6d69950819780b.png";